import { render, staticRenderFns } from "./FinanceTagCell.vue?vue&type=template&id=0bbcecfe"
import script from "./FinanceTagCell.vue?vue&type=script&lang=js"
export * from "./FinanceTagCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports